import {ListViewProvider, useListView} from './core/ListViewProvider'
import {QueryRequestProvider} from './core/QueryRequestProvider'
import {QueryResponseProvider} from './core/QueryResponseProvider'
import {KTCard} from '../../../../_metronic/helpers'
import {JudiListHeader} from './components/header/JudiListHeader'
import {JudiEditModal} from './judi-edit-modal/JudiEditModal'
import {JudiTable} from './table/JudiTable'
import {useAuth} from '../../auth'
import {LevelEnum} from '../../../enums/LevelEnum'
import {ReportStatusEnum} from '../../../enums/ReportStatusEnum'

const JudiList = () => {
  const {itemIdForUpdate} = useListView()

  return (
    <>
      <div className='d-flex flex-row justify-content-between mb-8'>
        <h1 className='page-heading text-dark fw-bold fs-3 my-0'>Judi Konvensional</h1>
      </div>
      <KTCard>
        <JudiListHeader />
        <JudiTable />
      </KTCard>
      {itemIdForUpdate !== undefined && <JudiEditModal />}
    </>
  )
}

const JudiListWrapper = () => {
  return (
    <QueryRequestProvider>
      <QueryResponseProvider>
        <ListViewProvider>
          <JudiList />
        </ListViewProvider>
      </QueryResponseProvider>
    </QueryRequestProvider>
  )
}

export {JudiListWrapper}
